import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { MESSAGES } from "./message.mock";
var _data = /*#__PURE__*/new WeakMap();
var _extend = /*#__PURE__*/new WeakMap();
export var Message = /*#__PURE__*/function () {
  function Message() {
    var _this = this;
    _classCallCheck(this, Message);
    _classPrivateFieldInitSpec(this, _data, void 0);
    _classPrivateFieldInitSpec(this, _extend, function (target, source) {
      for (var key in source) {
        if (source.hasOwnProperty(key)) {
          if ({}.toString.call(source[key]) !== "[object Undefined]") {
            if ({}.toString.call(source[key]) !== "[object Object]") {
              target[key] = source[key];
            } else {
              if ({}.toString.call(target[key]) !== "[object Object]") {
                target[key] = {};
              }
              _classPrivateFieldGet(_extend, _this).call(_this, target[key], source[key]);
            }
          }
        }
      }
      for (var _len = arguments.length, last = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        last[_key - 2] = arguments[_key];
      }
      if (last.length > 0) {
        return _classPrivateFieldGet(_extend, _this).apply(_this, [target].concat(last));
      }
      return target;
    });
    _classPrivateFieldSet(_data, this, this.create());
  }
  return _createClass(Message, [{
    key: "get",
    value: function get(key) {
      return _classPrivateFieldGet(_data, this)[key];
    }
  }, {
    key: "create",
    value: function create() {
      return _classPrivateFieldGet(_extend, this).call(this, {}, MESSAGES);
    }
  }]);
}();